import { ReactElement, useState } from 'react'
import { Button } from '../../../../../src/ui-components/forms/Button'
import SearchIcon from '@mui/icons-material/Search'
import styled from 'styled-components'
import { I18n } from 'common'
import { StoreInstances } from '../../../../../src/store/StoreInstancesContainer'
import { ContactUsDrawer } from '../../../../../src/features/navigation/header/contactUs/ContactUsDrawer'
import { useNavigate } from 'react-router-dom'
import { defaultTheme } from 'src/theme'

interface HDNoResultsI {
  partNumber: string
}

const HDNoResults = (props: HDNoResultsI): ReactElement => {
  const { partNumber } = props
  const [isContactUsDrawerOpen, setIsContactUsDrawerOpen] = useState(false)
  const crossReferenceEnabled =
    StoreInstances.userStore.preferences.crossReference === 'true'
  const invalidInterchangePartSearch =
    StoreInstances.searchStore.invalidInterchangePart
  const navigate = useNavigate()
  const goToContactUsPage = () => {
    setIsContactUsDrawerOpen(true)
  }
  const closeContactUsDrawer = () => {
    setIsContactUsDrawerOpen(false)
  }
  const navigateToCrossReferenceTab = () => {
    navigate(`/cross-reference?partNumber=${partNumber}`)
  }
  return (
    <div>
      <HdNoResultsWrapper>
        <HdSearchIconStyled />
        <HdNoResultsContentWrapper>
          <HdContentWrapper>
            <HdNoResultsTitle>
              <I18n name="noResultsFoundForHD" textReplacement={[partNumber]} />
            </HdNoResultsTitle>
            <HdNoResultsContent>
              <div>
                <HdNoResultsSubContent>
                  {invalidInterchangePartSearch ? (
                    <I18n
                      name="partIsNotVaildText"
                      textReplacement={[partNumber]}
                    />
                  ) : (
                    <I18n
                      name="partIsValidText"
                      textReplacement={[partNumber]}
                    />
                  )}
                </HdNoResultsSubContent>

                <HdNoResultsSubText>
                  {invalidInterchangePartSearch ? (
                    <I18n
                      name="partIsNotVaildSubText"
                      textReplacement={[partNumber]}
                    />
                  ) : (
                    <I18n
                      name="partIsValidSubText"
                      textReplacement={[partNumber]}
                    />
                  )}
                </HdNoResultsSubText>
              </div>
              <HdContactUsText>
                <I18n name="feelFreeToReachTextHD" />
              </HdContactUsText>
            </HdNoResultsContent>
          </HdContentWrapper>
          <HdEventsSection>
            <Button
              text="contactUs"
              variant="secondary"
              onClick={() => goToContactUsPage()}
            />
            {crossReferenceEnabled && (
              <Button
                text="crossReferenceToolNoResults"
                onClick={() => navigateToCrossReferenceTab()}
                style={{
                  backgroundColor: `${defaultTheme.colors.blueLight}`,
                  color: 'white',
                  border: 'none',
                }}
              />
            )}
          </HdEventsSection>
          <ContactUsDrawer
            open={isContactUsDrawerOpen}
            onCloseDrawer={closeContactUsDrawer}
          />
        </HdNoResultsContentWrapper>
      </HdNoResultsWrapper>
    </div>
  )
}

export default HDNoResults

const HdNoResultsWrapper = styled.div`
  display: flex;
  background-color: white;
  column-gap: 48px;
  padding-top: 89px;
  padding-left: 253.5px;
  padding-right: 261.5px;
  min-height: 500px;
`
const HdSearchIconStyled = styled(SearchIcon)`
  color: #d3d2cf;
  font-size: 150px !important;
`
const HdNoResultsContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  max-width: 690px;
`
const HdNoResultsTitle = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  font-family: Oswald, serif;
`
const HdNoResultsContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 24px;
`
const HdNoResultsSubContent = styled.div`
  color: #191919;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  font-family: Roboto, serif;
`
const HdNoResultsSubText = styled.div`
  color: #191919;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  font-family: Roboto, serif;
`
const HdContactUsText = styled.div`
  color: #191919;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  font-family: Roboto, serif;
`
const HdEventsSection = styled.div`
  display: flex;
`

const HdContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`
